import { put, takeLatest } from 'redux-saga/effects';
import handleException from './../services/handleException';
import { deleteItem, update, upload, saveMasterUpdateSetting as saveSetting, getMasterUpdateSetting as getSetting } from './../utils/settingMerchant';
import { getListItemName } from './../utils/getListItemName'

function* saveMerchantHandle(data) {
    try {
        const json = yield upload(data.payload)
        if (json.data.code == 10001) {
            yield put({
                type: 'SAVE_MERCHANT_SUCCESS',
                json: json.data.data,
            })
        }
        else {
            handleException(json)
            yield put({
                type: 'UPLOAD_MERCHANT_FAILURE'
            })
        }
    } catch (error) {
        handleException(error)
    }
}

export function* settingMerchantSaga() {
    yield takeLatest('ON_UPLOAD_MERCHANT', saveMerchantHandle)
}

function* updateMerchantHandle(action) {
    try {
        const json = yield update(action.payload)
        if (json.data.code == 10001)
            yield put({
                type: 'UPDATE_MERCHANT_SUCCESS',
            })
        else {
            yield put({ type: 'UPDATE_MERCHANT_FAILURE', json })
            handleException(json)
        }
    } catch (error) {
        handleException(error)
        yield put({ type: 'UPDATE_MERCHANT_FAILURE', error })
    }
}

export function* updateMerchantSaga() {
    yield takeLatest('UPDATE_SAGA_ITEM', updateMerchantHandle)
}

function* deleteMerchantHandle(action) {
    try {
        const json = yield deleteItem(action.payload)
        if (json.data.code == 10001)
            yield put({
                type: 'DELETE_MERCHANT_SUCCESS',
            })
        else handleException(json)
    } catch (error) {
        handleException(error)
        yield put({
            type: 'SAVE_MERCHANT_FAILURE',
            error,
        })
    }
}

export function* deleteMerchantSaga() {
    yield takeLatest('DELETE_SAGA_MERCHANT', deleteMerchantHandle)
}

function* fetchMerchantHandle(data) {
    try {
        const json = yield getListItemName(data.payload)
        if (json.data.code == 10001) {
            let x = 0
            let result1 = json.data.data.result.AllItemNameResults.map(element => {
                element.key = x++
                return element
            })
            yield put({
                type: 'ON_LOAD_MERCHANT',
                result1,
                page: data.payload.Page,
                total_item: json.data.data.result.ItemNameCount,
            })
        } else handleException(json)
    } catch (error) {
        handleException(error)
        yield put({
            type: 'onLoadMerchant_FAILURE',
            error,
        })
    }
}

export function* fetchMerchantSaga() {
    yield takeLatest('FETCH_UPLOAD_MERCHANT', fetchMerchantHandle)
}

export function* getMasterUpdateSettingSaga() {
    yield takeLatest('ON_LOAD_SETTING', getMasterUpdateSetting)
}

function* getMasterUpdateSetting() {
    try {
        const json = yield getSetting()

        if (json.data.code == 10001) {
            yield put({
                type: 'ON_LOAD_SETTING_SUCCESS',
                payload: json.data
            })
        } else {
            handleException(json)
        }
    } catch (error) {
        handleException(error)
        yield put({
            type: 'ON_LOAD_SETTING_FAIL',
            error,
        })
    }
}

export function* saveMasterUpdateSettingSaga() {
    yield takeLatest('ON_SAVE_SETTING', saveMasterUpdateSetting)
}

function*  saveMasterUpdateSetting(data) {
    try {
        const json = yield saveSetting(data.payload)
        if (json.data.code == 10001) {
            yield put({
                type: 'ON_SAVE_SETTING_SUCCESS',
                payload: data.payload
            })
        } else {
            handleException(json)
        }
    } catch (error) {
        handleException(error)
        yield put({
            type: 'ON_SAVE_SETTING_FAIL',
            error,
        })
    }
}



// WEBPACK FOOTER //
// ./src/sagas/settingMerchantSaga.js